<template>
  <v-main class="b-layout-empty">
    <template v-if="loading">
      <v-overlay
        :value="loading"
        :z-index="4"
        :absolute="absolute"
        color="white"
        class="b-layout-empty__overlay"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-overlay>
    </template>

    <slot name="before" />

    <v-container fluid>
      <slot />
      <slot name="container" />
    </v-container>

    <slot name="after" />
  </v-main>
</template>

<script>

export default {
  name: 'BLayoutEmpty',
  props: {
    loading: Boolean,
    absolute: Boolean,
  },
}
</script>

<style lang="scss">

$height-header: 64px;
$correct: $height-header;

.b-layout-empty {
  .v-main__wrap {
    display: flex;
    flex-direction: column;
  }

  &__overlay {
    position: sticky;
    top: $correct;
    height: calc(100vh - #{$correct});
    max-height: 100%;
    margin-bottom: calc(-100vh + #{$correct});
  }
}
</style>
